import { createSlice } from '@reduxjs/toolkit';
import { IExperiment } from '../../types/experiments';

const initialState: IExperiment[] = [];

const experimentsSlice = createSlice({
  name: 'experiments',
  initialState,
  reducers: {
    experimentsReducer(state) {
      return state;
    },
  },
  extraReducers: {},
});

export const { reducer: experimentsReducer } = experimentsSlice;
